import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import Paper from '@material-ui/core/Paper';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import { Container } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import * as React from 'react';
import { useState } from 'react';
import { User } from '../../../utils/user';
import { DeleteButton } from 'components/DeleteButton/DeleteButton';
import { useAppUserAccountDelete } from '../../../types/generated';
import { ConfirmDialog } from '../../../components/ConfirmDialog/ConfirmDialog';

interface UserListViewProps {
    list: any[];
    user: User | null;
    onDelete: () => void;
}

export const UserListView = ({ onDelete, list, user: authenticatedUser }: UserListViewProps) => {
    const [userToDelete, setUserToDelete] = useState<User | undefined>();
    const [deleteUser, { loading }] = useAppUserAccountDelete();

    const deactivateUser = async (id: string) => {
        await deleteUser({
            variables: {
                id,
            },
        });

        onDelete();
    };

    return (
        <>
            {userToDelete && (
                <ConfirmDialog
                    open={Boolean(userToDelete)}
                    close={() => setUserToDelete(undefined)}
                    title={'Delete user?'}
                    onConfirm={() => deactivateUser(userToDelete.id)}
                >
                    <p>
                        Are you sure you want to delete{' '}
                        {userToDelete.firstName + ' ' + userToDelete.lastName}? This action cannot
                        be undone.
                    </p>
                </ConfirmDialog>
            )}
            <Container maxWidth="md">
                <Paper>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>User</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list.map(({ node: user }) => (
                                <TableRow key={user.id}>
                                    <TableCell>
                                        {user.firstName} {user.lastName}
                                    </TableCell>
                                    <TableCell>{user.email}</TableCell>
                                    <TableCell align={'right'}>
                                        <Button
                                            to={`/extranet/team/${user.id}`}
                                            component={RouterLink}
                                        >
                                            Edit
                                        </Button>
                                        {authenticatedUser?.accountOwner &&
                                            authenticatedUser.id !== user.id && (
                                                <DeleteButton
                                                    disabled={loading}
                                                    onClick={() => setUserToDelete(user)}
                                                >
                                                    Remove
                                                </DeleteButton>
                                            )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Paper>
            </Container>
        </>
    );
};
